/**
 * Renders our sub-header. i.e. add new field, add new action, etc.
 *
 * @package Ninja Forms builder
 * @subpackage App
 * @copyright (c) 2015 WP Ninjas
 * @since 3.0
 */
define( 'views/app/subHeader',[], function() {
	var view = Marionette.ItemView.extend({
		tagName: 'div',
		template: '#tmpl-nf-sub-header'
	});

	return view;
} );
